import {
  API_RESULT,
  BusinessUnit,
  COLLECT_CARD_INSTRUCTION,
  DIGITAL_AGENT_BUTTONS,
  RecordingState,
  URL_SOURCE_TYPE,
  UserPlatform,
} from "./enums";

export type GetReq = {
  fullUrl?: string;
  url?: string;
  loading?: boolean;
  isRefreshed?: boolean;
  hideLoader?: boolean;
};

export type PostReq = GetReq & {
  body?: Object;
};
export type POPUP_CONTENT = {
  show: boolean;
  type: string;
  image?: object;
  title: string;
  subTitle?: string;
  okBtnText?: string;
  cancelBtnText?: string;
  okBtnAction?: number;
  cancelBtnAction?: number;
  props?: any;
  img?: string;
  mobileImg?: string;
  body?: string;
  withButton?: boolean;
  strings?: object;
  hideCloseBtn?: boolean;
  bodyList?: MustListBodyList[];
  errorStatus?: number;
  withBuyPolicyBtn?: boolean;
  buyPolicyBtnText?: string;
};

export type CASE_DATA_REQUEST = {
  email: string;
  issue: string;
  reason: string;
  details: string;
  id_number: string;
};
export type Tokens = {
  xSessionId: string;
};
export type Headers = {
  Accept: string;
  "Content-Type": string;
  Authorization: string;
};
export type USER_INFO = {
  email: string;
  address: string;
  zip: string;
  city: string;
  apartment: string;
};

export type DropDown = {
  id: string;
  name: string;
};
export type TranslationsResponse = {
  responseMessage: string;
  responseCode: string;
  responseData: {
    strings: Translations;
  };
};
export type ResponseError = {
  responseCode: string;
  responseMessage: string;
  error: ErrMessage;
};
export type ErrMessage = {
  message: string;
};
export type Translations = {
  t_please_select_from_the_list: string;
  somethingWentWrong: string;
  t_wrong_otp_error: string;
  t_digit_entry_message: string;
  t_otp_format: string;
  t_risk_country_info_text: string;
  t_401_error_popup_title: string;
  t_401_error_popup_find_button: string;
  t_401_error_popup_body: string;
  t_towards_step: string;
  t_summary_sub_title_question: string;
  acc_t_towards_step: string;
  acc_t_summary_sub_title_question: string;
  t_click_here: string;
  loading_page: string;
  acc_loading_page: string;
  t_loader_title: string;
  acc_t_loader_title: string;
  t_loader_description: string;
  acc_t_loader_description: string;
  t_summary_card_instruction_collect: string;
  acc_t_summary_card_instruction_collect: string;
  t_summary_card_instruction_replace: string;
  acc_t_summary_card_instruction_replace: string;
  t_global_blue_not_supported_country: string;
  t_global_blue_already_registered: string;
  t_error_popup_page_not_found_title: string;
  t_error_popup_page_not_found_body: string;
  t_tax_refund_general_error_message: string;
  t_tax_refund_general_error_title: string;
  t_toggle_step_open: string;
  acc_t_toggle_step_open: string;
  acc_t_toggle_step_disabled: string;
  t_active_credit_card_brand_not_authorized: string;
  acc_t_active_credit_card_brand_not_authorized: string;
  t_tax_refaund_yellow_banner_title: string;
  t_active_credit_card_will_expire: string;
  t_active_credit_personal_id_mismatch: string;
  t_active_credit_card_brand_not_authorized_other_cards: string;
  t_active_credit_debit_card_other_cards: string;
  t_active_credit_not_israeli_card_other_cards: string;
  t_active_credit_card_general_error_other_cards: string;
  t_active_credit_card_will_expire_other_cards: string;
  t_active_credit_personal_id_mismatch_other_cards: string;
  t_active_credit_not_israeli_card: string;
  t_active_credit_debit_card: string;
  t_active_credit_not_israeli_and_debit_card: string;
  t_active_credit_active_card: string;
  t_active_credit_not_active_card: string;
  t_toggle_step_close: string;
  acc_t_toggle_step_close: string;
  t_card_details: string;
  t_active_credit_how_it_works: string;
  t_active_credit_title: string;
  t_active_credit_sub_title: string;
  t_active_credit_more_info: string;
  acc_t_active_credit_more_info: string;
  t_active_credit_choose_payment_method: string;
  acc_t_active_credit_choose_payment_method: string;
  t_active_credit_last_card: string;
  acc_t_active_credit_last_card: string;
  t_active_credit_saved_cards: string;
  t_active_credit_add_other_payment: string;
  acc_t_active_credit_add_other_payment: string;
  t_active_credit_replace_other_payment: string;
  acc_t_active_credit_replace_other_payment: string;
  t_active_credit_accept: string;
  acc_t_active_credit_accept: string;
  t_active_credit_terms: string;
  acc_t_active_credit_terms: string;
  t_active_credit_checkbox_text: string;
  acc_t_active_credit_checkbox_text: string;
  t_active_credit_next: string;
  t_active_credit_next_disabled: string;
  acc_t_active_credit_next_disabled: string;
  t_card_item_card_number: string;
  t_card_item_expiration_date: string;
  t_tax_refaund_how_it_works: string;
  t_tax_refaund_title: string;
  t_tax_refaund_more_info: string;
  acc_t_tax_refaund_more_info: string;
  t_tax_refaund_more_info_aria_label: string;
  t_tax_refaund_banner_title: string;
  t_tax_refaund_banner_sub_title: string;
  t_tax_refaund_info_to_register: string;
  t_tax_refaund_info_to_register_sub_title: string;
  t_tax_refaund_info_passport_number: string;
  acc_t_tax_refaund_info_passport_number: string;
  t_tax_refaund_expiration_date: string;
  t_tax_refaund_expiration_date_text_aria: string;
  acc_t_tax_refaund_expiration_date_text_aria: string;
  t_tax_refaund_state_of_issue: string;
  acc_t_tax_refaund_state_of_issue: string;
  t_tax_refaund_nation: string;
  acc_t_tax_refaund_nation: string;
  t_tax_refaund_next: string;
  acc_t_tax_refaund_next: string;
  t_tax_refaund_error_message: string;
  t_tax_refaund_edit: string;
  t_tax_refaund_pass_num: string;
  t_tax_refaund_tokef: string;
  t_update_contact_main_title: string;
  t_update_contact_phone: string;
  t_update_contact_phone_edit: string;
  acc_t_update_contact_phone_edit: string;
  t_update_contact_edit: string;
  t_update_contact_email_title: string;
  acc_t_update_contact_email_title: string;
  t_update_contact_email_title_wrapper: string;
  acc_t_update_contact_email_title_wrapper: string;
  t_update_contact_address_placeholder: string;
  acc_t_update_contact_address_placeholder: string;
  t_update_contact_zip: string;
  acc_t_update_contact_zip: string;
  t_update_contact_checkbox_text: string;
  acc_t_update_contact_checkbox_text: string;
  t_update_contact_save: string;
  t_benefits_update_contact_info: string;
  t_benefits_enable_card: string;
  acc_t_benefits_enable_card: string;
  t_benefits_accordion_title: string;
  acc_accordion_not_allowed: string;
  t_benefits_title: string;
  acc_t_benefits_title: string;
  t_update_contact_validation_required: string;
  t_update_contact_validation_wrong_zip: string;
  t_update_contact_validation_wrong_email: string;
  t_update_contact_validation_short_address: string;
  t_leads_transferring_title: string;
  t_leads_transferring_title_success: string;
  t_leads_transferring_sub_title: string;
  t_leads_transferring_what_next: string;
  t_leads_transferring_title1: string;
  t_leads_transferring_sub_title1: string;
  t_leads_transferring_title2: string;
  t_leads_transferring_sub_title2: string;
  t_leads_transferring_title3: string;
  t_leads_transferring_sub_title3: string;
  t_leads_transferring_success_message: string;
  t_sms_transferring_success_message: string;
  t_sms_transferring_success_message_sub_title: string;
  t_leads_transferring_success_message_sub_title: string;
  t_tax_refaund_validation_required: string;
  t_login_title: string;
  acc_t_login_title: string;
  t_login_sub_title: string;
  acc_t_login_sub_title: string;
  t_login_id: string;
  t_login_id_error_message: string;
  t_login_phone: string;
  t_login_phone_error_message: string;
  t_login_checkbox_text: string;
  t_login_checkbox_text_link: string;
  t_login_button: string;
  t_otp_subTitle: string;
  acc_t_otp_subTitle: string;
  t_otp_placeholder: string;
  t_otp_placeholder_info: string;
  t_choose_policy_title: string;
  acc_t_choose_policy_title: string;
  t_opt_error_message: string;
  t_choose_policy_sub_title: string;
  acc_t_choose_policy_sub_title: string;
  t_choose_policy_destination: string;
  t_choose_passengers: string;
  t_choose_policy_dates: string;
  t_active_credit_banner_title: string;
  acc_t_active_credit_banner_title: string;
  t_active_credit_banner_sub_title: string;
  acc_t_active_credit_banner_sub_title: string;
  t_active_credit_banner_sub_title_second_part: string;
  acc_t_active_credit_banner_sub_title_second_part: string;
  t_back: string;
  acc_t_back: string;
  t_send_again: string;
  t_login_first_name_error_message: string;
  t_login_last_name_error_message: string;
  t_login_first_name: string;
  acc_t_login_first_name: string;
  t_login_last_name: string;
  acc_t_login_last_name: string;
  t_error_popup_cant_move_title: string;
  t_error_popup_cant_move_body: string;
  t_error_popup_cant_move_button: string;
  t_error_popup_debt_title: string;
  t_error_popup_debt_body: string;
  t_error_popup_debt_button: string;
  t_error_popup_cant_find_title: string;
  t_error_popup_cant_find_body: string;
  t_error_popup_cant_find_button: string;
  t_summary_title: string;
  acc_t_summary_title: string;
  t_summary_sub_title: string;
  acc_t_summary_sub_title: string;
  t_summary_body: string;
  acc_t_summary_body: string;
  t_summary_description: string;
  acc_t_summary_description: string;
  t_summaty_footer_text1: string;
  acc_t_summaty_footer_text1: string;
  acc_t_summaty_footer_text2: string;
  t_summaty_footer_text2: string;
  t_addon_one_title: string;
  t_addon_one_body: string;
  t_addon_two_title: string;
  t_addon_two_body: string;
  t_addon_three_title: string;
  t_addon_three_body: string;
  t_addon_one_btn: string;
  t_addon_two_btn: string;
  t_addon_three_btn: string;
  t_summary_button: string;
  acc_t_summary_button: string;
  t_summary_mobile_title: string;
  acc_t_summary_mobile_title: string;
  t_digiral_agent_title: string;
  t_digiral_agent_body: string;
  t_digiral_agent_list_title: string;
  t_digital_agent_item1_title: string;
  t_digital_agent_item2_title: string;
  t_digital_agent_list_sub_title: string;
  t_digital_agent_contact_button: string;
  t_digital_agent_send_button: string;
  t_digital_agent_dissmis_button: string;
  t_digital_agent_dissmis_button_aria_label: string;
  t_faq_credit_card_title: string;
  t_faq_credit_card_sub_title: string;
  t_faq_credit_card_body: string;
  t_faq: string;
  t_faq_credit_card_question_one: string;
  t_faq_credit_card_answer_one: string;
  t_faq_credit_card_question_two: string;
  t_faq_credit_card_answer_two: string;
  t_faq_credit_card_question_three: string;
  t_faq_credit_card_answer_three: string;
  t_faq_credit_card_button: string;
  t_tax_refaund_popup_title: string;
  t_tax_refaund_popup_sub_title: string;
  t_tax_refaund_popup_body: string;
  t_tax_refauld_popup_faq: string;
  t_tax_refaund_popup_button: string;
  t_tax_refaund_popup_question_one: string;
  t_tax_refaund_popup_answer_one: string;
  t_tax_refaund_popup_question_two: string;
  t_tax_refaund_popup_answer_two: string;
  t_tax_refaund_popup_question_three: string;
  t_tax_refaund_popup_answer_three: string;
  t_city: string;
  acc_t_city: string;
  t_apartment: string;
  acc_t_apartment: string;
  t_why_we_need_adress: string;
  acc_t_why_we_need_adress: string;
  t_summary_dgeshim: string;
  acc_t_summary_dgeshim: string;
  t_summary_dgeshim_qr: string;
  t_active_credit_card_error: string;
  acc_t_active_credit_card_error: string;
  t_active_credit_date_error: string;
  t_backToBenefits: string;
  acc_t_backToBenefits: string;
  t_digital_fail_message: string;
  t_share_title: string;
  t_share_text: string;
  t_popupTitleError: string;
  t_popupTextHelpMarketing: string;
  t_popupTextHelpLead: string;
  t_errorTitleDebt: string;
  t_errorTextDebtMarketing: string;
  t_errorTextDebtLead: string;
  t_wrongId: string;
  t_popupTitleNoInsuranceMarketing: string;
  t_popupTextNoInsuranceMarketing: string;
  t_popupTextNoInsuranceLead: string;
  t_popupTitleCustomerNotFound: string;
  t_popupTextCustomerNotFound: string;
  t_popupTitleServiceNotAvailable: string;
  t_popupTextServiceNotAvailable: string;
  t_popupTitleAgeRestriction: string;
  t_popupTextAgeRestriction: string;
  t_popupTitleAlreadyRegisteredMarketing: string;
  t_popupTextAlreadyRegisteredMarketing: string;
  t_popupTitleAlreadyRegisteredLead: string;
  t_popupTextAlreadyRegisteredLead: string;
  t_popupTitleMissingDetailsMarketing: string;
  t_popupTextMissingDetailsMarketing: string;
  t_popupTitleMissingDetailsLead: string;
  t_popupTextMissingDetailsLead: string;
  t_messageDifferentPhone: string;
  t_login_error: string;
  t_no_results_found: string;
  acc_t_no_results_found: string;
  t_card_details_first_name: string;
  t_card_details_id: string;
  t_card_holder_details: string;
  t_iframe_response_1: string;
  t_iframe_response_2: string;
  t_iframe_response_3: string;
  t_iframe_response_4: string;
  t_iframe_response_5: string;
  t_iframe_response_6: string;
  t_iframe_response_7: string;
  t_inquire_cg_iframe_result_error: string;
  t_cg_inquiry_cg_iframe_failed: string;
  t_cg_no_iframe_url: string;
  t_otp_invalid_code: string;
  t_otp_expired_code: string;
  t_otp_blocked_user: string;
  t_login_general_error_title: string;
  t_login_general_error_text: string;
  t_otp_one_or_more_wrong_fields: string;
  t_leads_transferring_error_message: string;
  t_must_list_title: string;
  acc_t_must_list_title: string;
  t_must_list_sub_title: string;
  acc_t_must_list_sub_title: string;
  t_must_list_body_question_1: string;
  acc_t_must_list_body_question_1: string;
  t_must_list_body_question_2_collect: string;
  t_must_list_body_question_2_replace: string;
  t_must_list_body_question_2_use_existing: string;
  acc_t_must_list_body_question_2_collect: string;
  acc_t_must_list_body_question_2_replace: string;
  acc_t_must_list_body_question_2_use_existing: string;
  t_passportCard_il: string;
  t_card_restrictions_button: string;
  acc_t_card_restrictions_button: string;
  t_must_list_body_question_3: string;
  acc_t_must_list_body_question_3: string;
  t_must_list_body_question_4: string;
  acc_t_must_list_body_question_4: string;
  t_must_list_body_question_5: string;
  acc_t_must_list_body_question_5: string;
  t_must_list_body_question_6: string;
  acc_t_must_list_body_question_6: string;
  t_summaty_footer_text3: string;
  acc_t_summaty_footer_text3: string;
  t_must_list_body_question_7: string;
  acc_t_must_list_body_question_7: string;
  t_must_list_body_question_8: string;
  acc_t_must_list_body_question_8: string;
  t_must_list_body_question_9: string;
  acc_t_must_list_body_question_9: string;
  t_must_list_accept_text: string;
  acc_t_must_list_accept_text: string;
  t_must_list_accept_button: string;
  acc_t_must_list_accept_button: string;
  t_footer_accessibility_statement: string;
  t_footer_security_statement: string;
  t_footer_privacy_policy: string;
  t_footer_terms_of_use: string;
  t_must_list_error_message: string;
  acc_t_must_list_error_message: string;
  t_global_blue_sub_title: string;
  acc_t_global_blue_sub_title: string;
  t_global_blue_accordion_title: string;
  acc_t_global_blue_accordion_title: string;
  t_global_blue_checkbox_text: string;
  t_global_blue_success_title: string;
  acc_t_global_blue_success_title: string;
  t_global_blue_success_subtitle: string;
  acc_t_global_blue_success_subtitle: string;
  t_active_credit_card_error_message: string;
  acc_t_active_credit_card_error_message: string;
  t_tax_refund_RC_1: string;
  t_tax_refund_RC_2: string;
  t_tax_refund_RC_3: string;
  t_fullName: string;
  t_tax_refaund_general_error_message: string;
  t_active_credit_not_israeli_and_debit_card_other_cards: string;
  t_active_credit_general_error: string;
  t_global_blue_sub_title_1: string;
  acc_t_global_blue_sub_title_1: string;
  t_global_blue_sub_title_2: string;
  acc_t_global_blue_sub_title_2: string;
  t_global_blue_sub_title_3: string;
  acc_t_global_blue_sub_title_3: string;
  acc_t_clear_field: string;
  aria_t_passengers: string;
  t_digital_agent_checkbox_text: string;
  t_pc_plus_title: string;
  acc_t_pc_plus_title: string;
  t_pc_plus_what_the_service_includes_title: string;
  acc_t_pc_plus_what_the_service_includes_title: string;
  acc_t_pc_plus_what_the_service_includes_sub_title: string;
  t_pc_plus_what_the_service_includes_list_item_title_1: string;
  t_pc_plus_what_the_service_includes_list_item_title_2: string;
  t_pc_plus_what_the_service_includes_list_item_title_3: string;
  t_pc_plus_what_the_service_includes_list_item_sub_title_1: string;
  t_pc_plus_what_the_service_includes_list_item_sub_title_2: string;
  t_pc_plus_what_the_service_includes_list_item_sub_title_2_option_1: string;
  t_pc_plus_what_the_service_includes_list_item_sub_title_2_option_2: string;
  t_pc_plus_what_the_service_includes_list_item_sub_title_2_option_3: string;
  t_pc_plus_what_the_service_includes_list_item_sub_title_3: string;
  t_pc_plus_what_the_service_includes_footer_title: string;
  t_pc_plus_what_the_service_includes_footer_option1: string;
  t_pc_plus_what_the_service_includes_footer_option2: string;
  t_pc_plus_what_the_service_includes_footer_option3: string;
  t_pc_plus_next_button: string;
  acc_t_pc_plus_next_button: string;
  t_activate_creditCard_point1: string;
  acc_t_activate_creditCard_point1: string;
  t_activate_creditCard_point2: string;
  acc_t_activate_creditCard_point2: string;
  t_activate_creditCard_point3: string;
  acc_t_activate_creditCard_point3: string;
  t_activate_creditCard_point4: string;
  acc_t_activate_creditCard_point4: string;
  t_activate_creditCard_point5: string;
  acc_t_activate_creditCard_point5: string;
  t_summary_screen_qr_code_ready: string;
  acc_t_summary_screen_qr_code_ready: string;
  t_active_checkbox_label: string;
  t_faq_credit_card_question_four: string;
  t_faq_credit_card_answer_four: string;
  t_faq_credit_card_question_five: string;
  t_faq_credit_card_answer_five: string;
  t_activate_credit_card_termsOfService: string;
  t_activate_credit_card_servicePricing: string;
  t_tax_refund_termsOfService: string;
  t_tax_refund_servicePricing: string;
  acc_t_tax_refaund_policy_text: string;
  acc_t_tax_refaund_3rd_party_policy_text: string;
  acc_cell_number: string;

  acc_enter: string;
  acc_numbers: string;
  acc_for_policy_choice: string;
  acc_for: string;
  t_summary_description_mobile: string;
  acc_t_summary_description_mobile: string;
  t_update_contact_email_not_valid: string;
  t_update_contact_validation_wrong_apartment: string;
  t_update_contact_validation_wrong_apartment_max_length: string;
  t_tax_refaund_validation_wrong_passport: string;
  t_tax_refund_expiration_date: string;
  t_back_button_benefits: string;
  t_inquire_cg_iframe_result_error_no_cards: string;
  t_active_credit_card_fx_general_error: string;
  t_active_credit_card_fx_general_error_other_cards: string;

  t_active_credit_card_fx_brand_not_authorized: string;
  t_active_credit_card_fx_brand_not_authorized_other_cards: string;
  t_active_credit_card_fx_will_expire: string;
  t_active_credit_card_fx_personal_id_mismatch: string;
  t_active_credit_card_fx_personal_id_mismatch_other_cards: string;

  t_active_credit_card_fx_not_israeli_card: string;
  t_active_credit_card_fx_not_israeli_card_other_cards: string;

  t_active_credit_card_fx_debit_card: string;
  t_active_credit_card_fx_debit_card_other_cards: string;

  t_active_credit_card_fx_debit_and_not_israeli: string;
  t_active_credit_card_fx_debit_and_not_israeli_other_cards: string;
  eligibiliryErrorPopupUnsupportedCountry: string;
  eligibiliryErrorPopupUnsupportedDestination: string;
  generalErrorIframeSessionExpired: string;
  generalErrorIframeContinueViaApp: string;
  t_buy_policy_button: string;
};

export enum CREDIT_CARD_BRAND {
  MASTERCARD = "1",
  VISA = "2",
}

export type CreditCard = {
  feCC4LastDigits: string;
  feCustCCExpirationDate: string;
  feCCCardBrand: CREDIT_CARD_BRAND;
  feCCcardMask: string;
  feCustCCStatus: string;
  index: number;
  feCCToken: string;
};

export type CustomerCreditCardResponse = {
  existingCustomer: boolean;
  creditCards: CreditCard[];
};
export enum CreditCardStatus {
  ACTIVE = "active",
  INACTIVE = "notActive",
}

export type PersonalDetails = {
  feCustFirstNameHeb: string;
  feCustLastNameHeb: string;
  feCustFirstNameEng: string;
  feCustLastNameEng: string;
  feCustCountryPhoneCode: string;
  feCustAreaCode: string;
  feCustPhone: string;
  feCustEmail: string;
  feCustGender: "male" | "female";
  feCustStreet: string;
  feCustCity: string;
  feCustCityName: string;
  feCustStreetName: string;
  feCustPostalCode: string;
  fePFSmarketingMailing: boolean;
  feServiceConditionConfirmation: boolean;
  feHouseNumber: number;
  feCustHouseNumber: number;
};

export type ResponseFxStatus = {
  message: string;
  code: string;
};

type PolicyDto = {
  travelPolicyNumberField: number;
  policyStartDateField: string;
  policyEndDateField: string;
  saleRepresentetiveIDField: number;
  isAnnualField: boolean;
  createdByField: number;
  policyPurchaseDateField: string;
  saleRepresentativeNameField: string;
  saleRepresentetiveIdField: number;
};

type LeadDetailsDto = {
  agentIDField: number;
  agentNameField: string;
  leadIDField: number;
  leadNoteField: string;
  numberOfPassangersField: number;
};

export type CountryOfDestinationDto = {
  countryField: string;
  countryISOField: string;
};

export type PolicyDetails = {
  policyDtoField: PolicyDto;
  leadDetailsDtoField: LeadDetailsDto;
  countryOfDestinationDtoField: CountryOfDestinationDto[];
};
export type PolicyDetailsUpdate = {
  feLeadNote: string;
  fePolicyEndDate: string;
  fePolicyDestinationISO: string[];
  fePolicyPurchaseDate: string;
  feAgentName: string;
  feCreatedBy: number;
  fePolicyId: string;
  fePolicyDestination: string[];
  fePolicyStartDate: string;
  fePolicyNumOfPassangers: number;
  fePolicyAgentId: string;
  feCollectCardInstructions: number;
  feSaleRepresentetiveId: number;
  feSaleRepresentetiveName: string;
};

export type UpdatePolicyRequest = {
  feVIPTypeID: string;
  feIsMarkedAsTesting: boolean;
  fePolicyDetails: PolicyDetailsUpdate;
  feCustPersId: string;
  feVIPCode: string;
  feSendAdsByEmailBy3rdParty: boolean;
  feBU: string;
};

export type CheckFxEligibilityResponse = {
  responseStatus: ResponseFxStatus;
  responseData: ResponseFxData;
};
export type CheckOrCreateOtpResponse = {
  responseMessage: string;
  responseCode: string;
};
export type UpdatePolicyResponse = {
  responseMessage: string;
  responseCode: string;
};
export type GeneralErrorResponse = {
  data: { responseStatus: ResponseFxStatus; responseData: ResponseFxData };
  error: Boolean;
  status: number;
};
export type GetCCInfoError = {
  data: {
    feCustTravelPolicyNumber: string;
    feCustPersonalId: string;
    feBU: string;
    error: {
      message: string;
    };
  };
};
export type CheckOrCreateOtpError = {
  error: boolean;
  status: number;
  data: {
    responseCode: number;
    responseMessage: string;
    error: {
      message: string;
    };
  };
};

export type CheckFxEligibilityRequest = {
  channel: number;
  personalId: string;
  salesExperimentVersionID?: string;
  versionName?: string;
  experimentType?: string;
  areaCode?: string;
  phone?: string;
  countryPhoneCode?: string;
  thirdPartyApproval?: string;
  guid?: string;
  businessUnit?: string | null;
  travelPolicyNumber?: string | null;
  agentId?: string | null;
  salesExperimentID?: string | null;
  experimentName?: string | null;
  feCampaignId?: string | null;
  feCampaignName?: string | null;
  userId?: string | null;
};
export enum PAYMENT_METHOD_INDICATION {
  GENERAL_ERROR = 4,
  CARD_BRAND_NOT_AUTHORIZED = 1,
  CARD_WILL_EXPIRE = 2,
  PERSONAL_ID_MISMATCH = 3,
  NOT_ISRAELI_CARD = 5,
  DEBIT_CARD = 6,
  NOT_ISRAELI_AND_DEBIT_CARD = 7,
  ACTIVE_CARD = 8,
  NOT_ACTIVE_CARD = 9,
}

export type ResponseFxData = {
  needToUpdatePhone: boolean;
  personalId: string;
  last4PhoneDigits: string;
  paymentMethodIndication: PAYMENT_METHOD_INDICATION;
  policyDetails: PolicyDetails[];
  collectCardInstruction: COLLECT_CARD_INSTRUCTION;
  responseMessage: string;
  passportCard4LastDigits: string;
  responseCode: number;
  isRiskCountry: boolean;
  sharedLink: string;
  leadButton: boolean;
  sessionId: string;
  enableSms: boolean;
  enableImmediateOnboard: boolean;
};

export type City = {
  name: string;
  id: string | number;
};
export type ChoosePolicyProps = {
  checkboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setChoosenPolicyItem: (policy: any) => void;
};

export type PolicyItemType = {
  index: number;
  passengers: string;
  dates: string;
  destination: string;
};
export type TextElements = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span";

export type MustListBodyList = {
  title: string;
  ariaLabel: string;
};
export type ServiceIncludesList = {
  image: string;
  imageWidth?: number;
  imageHeight?: number;
  title: string;
  subTitle: string;
  options?: string[];
};

export type StreetsResponse = {
  responseCode: string;
  streets: Street[];
};

export type Street = {
  streetId: number;
  streetName: string;
};
export type ZipCodeResponse = {
  zipCode: string;
};
export type UpdateContactDetailsResponse = {
  responseMessage: string;
  responseCode: string;
};
export type UpdateZipCodeResponse = {
  responseMessage: string;
  responseCode: string;
};
export type PostMessageData = {
  errorMessage?: string;
  responseCode?: string;
  status?: API_RESULT;
  buttonClicked?: DIGITAL_AGENT_BUTTONS;
  collectCardInstruction?: COLLECT_CARD_INSTRUCTION;
  passportCard4LastDigits?: string;
  errorCode?: number;
  pathname?: string;
};
export type CreateOrUpdateUserRequest = {
  feServiceConditionConfirmation?: boolean;
  feCustPersId: string;
  feCustTravelPolicyNumber: string;
  feOperationModel: number;
  feBU: string;
  feChannel: number;
};
export type CreateOrUpdateUserResponse = {
  responseMessage: string;
  responseCode: string;
};

export type GetTaxRefundInfoRequest = {
  feCustTravalPolicyNumber: string;
  feGuid: string;
  feCustPersId: string;
  feBU: string;
};
export type GetTaxRefundInfoResponse = {
  data: TaxRefundInfo;
  responseMessage: string;
  responseCode: string;
};
export type TaxRefundInfo = {
  feCustPassportNumber: string;
  feCustLastNameEnglish: string;
  feCustPassportNationality: string;
  feCustIssuingCountry: string;
  feCustPassportValidity: string;
  fe3rdPartyTaxRefund: boolean;
  feCustaxRefundEligibility: boolean;
  feCustFirstNameEnglish: string;
  feCustTaxRefundRegistration: boolean;
};

export type GetCountriesResponse = {
  countries: string[];
};
export type CreateTaxRefundMemberRequest = {
  feCustPassportNum: string;
  feIssuingCountry: string;
  feCustLastNameEnglish: string;
  feCustPassportNationality: string;
  feCustPersId: string;
  feCustPassportValidity: string;
  feBU: string;
  feCustFirstNameEnglish: string;
};
export type CreateTaxRefundMemberResponse = {
  responseMessage: string;
  responseCode: string;
};
export type SendLeadOrSmsResponse = {
  responseMessage: string;
  responseCode: string;
};
export type UpdateCCInfoResponse = {
  creditCards: {
    feCC4LastDigits: string;
    feCustCCExpirationDate: string;
    feCustCCStatus: string;
    feCCCardBrand: string;
    feCCcardMask: string;
  }[];
};
export type StartOnboardingEnsureResponse = {
  responseMessage: string;
  responseCode: string;
};
export type PausedActiveRecordingResponse = {
  responseMessage: string;
  responseCode: string;
};

export enum TAX_REFUND_CONDITION {
  ELIGIBLE_NOT_REGISTERED = "ELIGIBLE_NOT_REGISTERED",
  ELIGIBLE_AND_REGISTERED = "ELIGIBLE_AND_REGISTERED",
  REGISTERED_NOT_ELIGIBLE = "REGISTERED_NOT_ELIGIBLE",
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
}
export interface TaxRefundStatus {
  isRegistered: boolean;
  isEligible: boolean;
}
export const AUTH_REQUIRED_SOURCES = [
  URL_SOURCE_TYPE.SMS,
  URL_SOURCE_TYPE.CAMPAIGN,
  URL_SOURCE_TYPE.MARKETING,
  URL_SOURCE_TYPE.SMS_SHARE,
];
export const OTHER_SOURCES = [
  URL_SOURCE_TYPE.PFS_REP,
  URL_SOURCE_TYPE.REP_MANUAL,
  URL_SOURCE_TYPE.ENSURE,
];

export type CustomInputType = "id" | "phone" | "otp";

export type GetCitiesResponse = {
  cities: CityResponse[];
};
export type CityResponse = {
  city_id: string;
  name_hebrew: string;
  name_english: string;
};
export type StreetAndCityResponse = {
  street_id: string;
  name_hebrew: string;
  name_english: string;
  city_id: string;
};
export interface UpdateOnboardingAnalytics {
  fePfsSessionId: string;
  feCustPerslId?: string;
  feCustTravelPolicyNumber: string;
  feBu: BusinessUnit;
  feChannel: number;
  feUserPlatform: UserPlatform;
  feCreatedBy?: number;
  timeout?: boolean;
  abandon?: boolean;
  login_details?: boolean;
  login_otp?: boolean;
  login_choose_policy?: boolean;
  pc_plus?: boolean;
  ensure_agent_options?: boolean;
  update_contact_details?: boolean;
  activate_credit_card?: boolean;
  activate_credit_card_iframe?: boolean;
  activate_credit_card_qa?: boolean;
  must_list?: boolean;
  summary?: boolean;
  summary_global_blue?: boolean;
  summary_global_blue_qa?: boolean;
  summary_card_use_qa?: boolean;
  error_popup?: boolean;
  error_popup_code?: string;
  error_popup_desc?: string;
  campaign_id?: string;
  campaign_name?: string;
  campaign_source?: string;
  campaign_medium?: string;
  campaign_term?: string;
  campaign_content?: string;
  experiment_name?: string;
  experiment_type?: string;
  sales_experiment_id?: string;
  sales_experiment_version_id?: string;
  version_name?: string;
}
export type ExperimentData = {
  salesExperimentID: string;
  experimentName: string;
  salesExperimentVersionID: string;
  versionName: string;
  experimentType: string;
};
export type ErrorResponse = {
  responseStatus: {
    message: string;
    code: string;
  };
  responseData: {
    responseMessage: string;
    responseCode: string;
  };
};
export enum ResponseMessages {
  OTP_INVALID = "Invalid OTP",
  USER_BLOCKED = "User blocked",
}
export type InquiryGCIframeResultsError = {
  error: boolean;
  status: number;
  data: {
    responseCode: number;
    message: string;
    error: {
      message: string;
    };
  };
};
export type PausedActiveRecordingRequest = {
  feRecordingState: RecordingState;
  feAgentAD: string;
};
